import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import {
  COMMAND_NAME,
  TOOLBAR_NAME,
  TOOLBAR_LABEL,
  UI_NAME
} from "./constant";

export default class variableui extends Plugin {
  init() {
    this._createToolbarButton();
  }
  static get pluginName() {
    return UI_NAME;
   }

  _createToolbarButton() {
    const editor = this.editor;
    const flowVariableCommand = editor.commands.get(COMMAND_NAME);

    editor.ui.componentFactory.add(TOOLBAR_NAME, (locale) => {
      const view = new ButtonView(locale);
      view.set({
        label: TOOLBAR_LABEL,
        tooltip: true,
        withText: true,
        _tooltipString:TOOLBAR_LABEL,
        type:"button"
      });

      view.bind("isEnabled").to(flowVariableCommand, "isEnabled");
      
      this.listenTo(view, "execute", () => {
        console.log("testexecute");
        // 点击按钮的时候打开弹窗
        this.fire("openDilog");
      });
      return view;
    });
  }
}